const NS = 'SearchPage';
const CLS = 'searchPage';
const CLS_HIDE = 'd-none';
const CLS_MB_ACTIVE = 'is-mbActive';

import Handlebars from 'handlebars';
import { SearchFilterCheckboxWidget } from '../../../widgets/searchFilterCheckboxWidget/js/searchFilterCheckboxWidget';
import { utils } from '../../../../global/js/utils';
import { mediaQuery } from '../../../../global/js/wlc/mediaQuery';
import { spinnerService } from '../../../../global/js/wlc/spinnerService';
import { initPagination } from '../../../../global/js/pagination';
import { ifCond } from '../../../../../handlebarsHelpers';

export class SearchPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$topbar = this.$element.find(`.searchFilterTopBarWidget`);
		this.$fltBtnMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnMb`);
		this.$filterTagBtns = this.$element.find(`.searchFilterTopBarWidget-tag-btn`);
		this.$fltBtnCloseMb = this.$element.find(`.searchFilterTopBarWidget-fltBtnCloseMb`);

		this.$sidebar = this.$element.find(`.searchFilterSidebarWidget`);
		this.$filterTitlesList = this.$element.find(`.searchFilterSidebarWidget-filter-titles-btn`);
		this.$fltApplyBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltApplyBtnMb`);
		this.$fltResetBtnMb = this.$sidebar.find(`.searchFilterSidebarWidget-fltResetBtnMb`);
		this.$filterItemsList = this.$element.find(`.searchFilterSidebarWidget-filter-item`);
		this.$selects = this.$sidebar.find(`.searchFilterSidebarWidget-select`);

		this.$searchInp = this.$element.find(`.${CLS}-searchInput`);
		this.$searchInpClearBtn = this.$element.find(`.${CLS}-clearBtn`);
		this.$itemsList = this.$element.find(`.${CLS}-resultList`);
		this.$resultTxt = this.$element.find(`.${CLS}-resultTxt`);
		this.$pagination = this.$element.find(`.${CLS}-pagination`);

		this.spinnerService = spinnerService;
		this.siteId = this.$element.data('siteId');
		this.pageSize = this.$element.data('pageSize');
		this.getApi = this.$element.data('getItemsApi');
		this.results = this.$element.data('results');
		this.readmore = this.$element.data('readmore');
		this.emptyMessage = this.$element.data('emptyMessage');
		
		this.params = {
			siteId: this.siteId,
			pageNumber: 1,
			pageSize: this.pageSize,
			keyword: this.$searchInp.val() || ''
		};

		this.setItemTemplate();
		this.handleSearchInput();
		this.showClearBtn();
		this.initCheckbox();
		this.setCheckboxParam();
		this.handleSelect();
		this.setSelectParam();
		this.handleFilterBtnMb();
		this.handleFilterTitleTagBtns();

		if(!_.isEmpty(window.location.search)) {
			this.getItems();
		}

		this.$element.on('pagination.trigger', () => {
			this.getItems(true);
		});
	}

	// Search text input - on type
	handleSearchInput() {
		this.$searchInp.on('keyup', (event) => {
			this.showClearBtn();
			if(event.keyCode === 13) {
				this.params['keyword'] = $(event.currentTarget).val().trim();
				this.params.pageNumber = 1;
				this.getItems(true);
			}
		});

		this.$searchInpClearBtn.on('click', () => {
			this.$searchInp.val('');
			this.$searchInp.focus();
			this.showClearBtn();
		});
	}

	// Search text input - clear button
	showClearBtn() {
		let searchVal = this.$searchInp.val();
		if(searchVal) {
			this.$searchInpClearBtn.removeClass(CLS_HIDE);
		}
		else {
			this.$searchInpClearBtn.addClass(CLS_HIDE);
		}
	}

	// Search Results Template
	setItemTemplate() {
		let itemPartial = require('../../../widgets/searchResultItemWidget/tmpl/searchResultItemWidget.hbs');
		Handlebars.registerPartial('searchResultItemWidget', itemPartial);

		let template = `
			{{> searchResultItemWidget
				wg="searchResultItemWidget"
				ns="SearchResultItemWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);

		Handlebars.registerHelper('ifCond', ifCond);
	}

	// Get items (reload content)
	getItems(scrollToTop = false) {
		let url = this.getApi;

		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		this.$itemsList.empty();
		this.spinnerService.appendTo();
		this.updateUrl();

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				let items = data.results;

				if(items.length > 0) {
					items.forEach((item) => {
						item.readMoreLabel = this.readmore;
						let itemMarkup = this.itemTemplate(item);
						this.$itemsList.append(`${itemMarkup}`);
					});

					this.updateResultText({
						totalCount: data.totalCount,
						keyword: this.params.keyword
					});
				}
				else {
					this.updateResultText('');
				}

				if(scrollToTop) {
					this.$element.trigger('pagination.scrollToTop');
				}

				initPagination(this.pageSize, data.totalCount, this.$pagination, this);
				this.spinnerService.removeFrom();
			}
		});
	}

	// Update url after filters change
	updateUrl() {
		let uri = document.location.pathname;

		Object.keys(this.params).forEach((key, index) => {
			uri = utils.updateUrlParameter(uri, key, this.params[key]);
		});

		// update url without reload
		window.history.pushState('', '', uri);
	}

	// Update results text after filters change
	updateResultText(data) {
		this.$resultTxt.removeClass(CLS_HIDE);

		if(data) {
			this.$resultTxt.html(`${data.totalCount} ${this.results} ${data.keyword ? `"${data.keyword}"`: ''}`);
		}
		else {
			this.$resultTxt.html(this.emptyMessage);
		}
	}

	// Sidebar Checkboxes init
	initCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

		$checkboxWg.each((i, obj) => {
			new SearchFilterCheckboxWidget(obj, _.debounce((cbVal) => {
				this.params.pageNumber = 1;
				this.setCheckboxParam();

				if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.MD)) {
					this.getItems();
				}
			}, 500));
		});
	}

	// Sidebar Checkboxes listener
	setCheckboxParam() {
		const $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');
		const allCbVal = [];

		// Refresh Filter Tag Buttons
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);

		$checkboxWg.each((i, obj) => {
			const $el = $(obj);
			const cbVal = [];
			const elFilterKey = $el.data('filter-key');

			$el.find(`input[type="checkbox"]:checked`).each((i, ckbx) => {
				const cbValue = $(ckbx).val().toString();
				cbVal.push(cbValue);

				// Refresh Filter Tag Buttons
				_.each(this.$filterTagBtns, (obj) => {
					const $obj = $(obj);
					const filterKeyItem = $obj.data('filter-key').toString();
					const valueItem = $obj.data('value').toString();
					if(filterKeyItem === elFilterKey && valueItem === cbValue) {
						$obj.addClass(CLS_MB_ACTIVE);
					}
				});
			});

			allCbVal.push({
				name: elFilterKey,
				value: cbVal
			});
		});

		_.each(allCbVal, (obj, i) => {
			if(obj.value.length === 0) {
				delete this.params[obj.name];
			}
			else {
				this.params[obj.name] = obj.value.join(',');
			}
		});
	}

	// Filters toggle button
	handleFilterBtnMb() {
		this.$fltBtnMb.on('click', () => {
			if(this.$sidebar.hasClass(CLS_MB_ACTIVE)) {
				this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
				this.$sidebar.removeClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
			}
			else {
				this.$fltBtnMb.addClass(CLS_MB_ACTIVE);
				this.$sidebar.addClass(CLS_MB_ACTIVE);
				this.$fltBtnCloseMb.addClass(CLS_MB_ACTIVE);
			}
		});

		this.$fltBtnCloseMb.on('click', () => {1
			this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
			this.$sidebar.removeClass(CLS_MB_ACTIVE);
			this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
		});

		this.$fltApplyBtnMb.on('click', () => {
			this.$fltBtnMb.removeClass(CLS_MB_ACTIVE);
			this.$sidebar.removeClass(CLS_MB_ACTIVE);
			this.$fltBtnCloseMb.removeClass(CLS_MB_ACTIVE);
			this.getItems(true);
		});

		this.$fltResetBtnMb.on('click', () => {
			this.resetCheckbox();
			this.resetDropdown();
		});
	}

	// Sidebar filter titles (hover, click)
	handleFilterTitleTagBtns() {
		// New Filter Title Menu Buttons
		this.$filterTitlesList.on('click mouseover', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			this.$filterTitlesList.removeClass(CLS_MB_ACTIVE);
			$element.addClass(CLS_MB_ACTIVE);

			this.$filterItemsList.removeClass(CLS_MB_ACTIVE);
			_.each(this.$filterItemsList, (obj) => {
				let $obj = $(obj);
				let filterKeyItem = $obj.data('filter-key');
				if(filterKeyItem === filterKey) {
					$obj.addClass(CLS_MB_ACTIVE);
				}
			});
		});

		// New Filter Tag Buttons
		this.$filterTagBtns.on('click', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');
			let value = $element.data('value');
			let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

			$checkboxWg.each((i, obj) => {
				let $el = $(obj);

				if($el.data('filter-key') === filterKey) {
					$('input[type=checkbox][value="'+value+'"]', $el).prop('checked', false).trigger('change');
					$element.removeClass(CLS_MB_ACTIVE);
				}
			});
		});
	}

	// Sidebar Checkboxes reset
	resetCheckbox() {
		let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

		_.each($checkboxWg, (obj) => {
			let $obj = $(obj);
			let filterKey = $obj.data('filter-key');

			delete this.params[filterKey];
			$obj.find('input[type="checkbox"]').prop('checked', false);
		});

		// Refresh Filter Tag Buttons
		this.$filterTagBtns.removeClass(CLS_MB_ACTIVE);
	}

	// Sidebar Dates select
	handleSelect() {
		this.$selects.on('change', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');
			if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
				// Ensure that the filterKey does not match the current select value
				if(this.params[filterKey] !== $element.val()) {
					if(_.isNil($element.val()) || $element.val() === '') {
						delete this.params[filterKey];
					}
					else {
						this.params[filterKey] = $element.val();
					}

					this.params.pageNumber = 1;

					if(!mediaQuery.breakpointMaxWidth(mediaQuery.BREAKPOINTS.MD)) {
						this.getItems(true);
					}
				}
			}
		});
	}

	// Sidebar Dates set
	setSelectParam() {
		let selectVal = [];

		this.$selects.each((i, obj) => {
			if(obj.tagName !== 'SELECT') return;
			let $el = $(obj);
			let val = $el.val();
			selectVal.push({
				name: $el.data('filter-key'),
				value: val
			});
		});

		_.each(selectVal, (obj, i) => {
			if(obj.value.length === 0) {
				delete this.params[obj.name];
			}
			else {
				this.params[obj.name] = obj.value;
			}
		});
	}

	// Sidebar Dates reset
	resetDropdown() {
		_.each(this.$selects, (obj) => {
			let $obj = $(obj);
			let filterKey = $obj.data('filter-key');

			delete this.params[filterKey];
			$obj.val('').change();
		});
	}
}
